import { Textual }		from "@v3/data/textual";

import { CookieValue }	from "@v3/data/primitive/cookieValue";

// 6 byte/12 hex/48 bit time followed by 26 byte/52 hex/208 bit random in lower case hex encoding
export type Token	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"Token",
		/^[0-9a-f]{64}$/,
		"must be a hex-encoded token"
	);

namespace Extension {
	export const fromCookieValue	= (it:CookieValue):Token|null	=> Base.fromString(it);

	// this is legal, all our characters are safe for CookieValue
	export const toCookieValue		= (it:Token):CookieValue		=> CookieValue.brand(it);
}

export const Token	= { ...Extension, ...Base };
